import type { Node } from 'prosemirror-model';
import { TextSelection, type Selection } from 'prosemirror-state';

export function getCommentFromId(
	doc: Node,
	commentId: string
): Selection | null {
	let foundPos: number | null = null;

	// Recursively search through all nodes
	doc.descendants((node, pos) => {
		// Check marks on the current node
		const hasCommentMark = node.marks.some(
			(mark) =>
				mark.type.name === 'comment' && mark.attrs.commentID === commentId
		);

		if (hasCommentMark) {
			foundPos = pos;
			return false; // Stop searching
		}

		return true; // Continue searching
	});

	return foundPos ? new TextSelection(doc.resolve(foundPos + 1)) : null;
}
